import { gql } from "graphql-request";

export const GET_PRODUCTS = gql`
  query GetProducts($take: Int!, $skip: Int!, $where: ProductWhereInput! = {}) {
    products(where: $where, take: $take, skip: $skip, orderBy: { title: asc }) {
      id
      title
      selectedMaterial
      gender
      productType {
        name
      }
    }
  }
`;

export const GET_PRODUCT_RECOMMENDATIONS = gql`
  query GetProductRecommendations($productId: ID!) {
    productRecommendations(productId: $productId) {
      id
      title
      selectedMaterial
    }
  }
`;

export const GET_PRODUCT_SELECTION = gql`
  query GetProductSelection($productId: ID!, $clientId: String) {
    getProductSelectionState(productId: $productId, clientId: $clientId) {
      id
      productId
      selectedMaterial
      selectedSize
    }
  }
`;

export const GET_PRODUCT_SELECTIONS = gql`
  query GetProductSelections($productIds: [ID!]!, $clientId: String) {
    getProductSelectionStates(productIds: $productIds, clientId: $clientId) {
      id
      productId
      selectedMaterial
      selectedSize
    }
  }
`;

export const GET_TYPE_PRODUCTS = gql`
  query GetTypeProducts {
    products {
      productType {
        name
        requiresSizes
        image {
          publicUrl
          mimetype
          originalFilename
        }
      }
    }
  }
`;

export const GET_PRODUCT_TYPES = gql`
  query GetProductTypes {
    productTypes {
      id
      name
      requiresSizes
    }
  }
`;

export const GET_SIZES = gql`
  query GetSizes {
    sizes {
      id
      label
      value
      gender
      productType
    }
  }
`;

export const GET_MATERIAL_ICONS = gql`
  query GetMaterialIcons {
    materialIcons {
      id
      materialName
    }
  }
`;

export const GET_ADMIN_PRODUCTS = gql`
  query GetAdminProducts($take: Int!, $skip: Int!, $where: ProductWhereInput! = {}) {
    productsCount(where: $where)
    products(where: $where, orderBy: [{ createdAt: desc }], take: $take, skip: $skip) {
      id
      title
      gender
      price
      images(take: 1) {
        image {
          id
          publicUrl
          mimetype
          originalFilename
        }
      }
      productType {
        name
        requiresSizes
      }
      materialPrices {
        id
        materialName
        price
        isAvailable
        stockQuantity
      }
    }
  }
`;

export const GET_ADMIN_PRODUCT_MATERIAL_DETAILS = gql`
  query GetAdminProductMaterialDetails($productId: ID!, $materialPriceId: ID!) {
    product(where: { id: $productId }) {
      id
      materialPrices(where: { id: { equals: $materialPriceId } }) {
        id
        materialName
        price
        isAvailable
        stockQuantity
        sizes {
          id
          label
          value
          gender
          productType
        }
        variantInventories {
          id
          stockQuantity
          isAvailable
          product {
            id
          }
          size {
            id
            label
            value
          }
        }
        productImages {
          id
          image {
            id
            publicUrl
            mimetype
            originalFilename
          }
        }
      }
    }
  }
`;

export const GET_ADMIN_PRODUCT_VARIANT_INVENTORIES = gql`
  query GetAdminProductVariantInventories($id: ID!) {
    product(where: { id: $id }) {
      id
      materialPrices {
        id
        materialName
        price
        sizes {
          id
        }
        variantInventories {
          id
          stockQuantity
          isAvailable
          product {
            id
          }
          size {
            id
            label
            value
          }
        }
      }
    }
  }
`;

export const GET_ADMIN_USERS = gql`
  query GetAdminUsers($take: Int!, $skip: Int!, $where: UserWhereInput! = {}) {
    usersCount(where: $where)
    users(where: $where, orderBy: [{ createdAt: desc }], take: $take, skip: $skip) {
      id
      name
      email
      isAdmin
      createdAt
    }
  }
`;

export const GET_MATERIAL_ICONS_BY_PRODUCT_IDS = gql`
  query GetMaterialIconsByProductIds($ids: [ID!]!) {
    products(where: { id: { in: $ids } }) {
      id
      materialPrices {
        materialIcon {
          materialName
          icon {
            id
            publicUrl
          mimetype
          originalFilename
          }
        }
      }
    }
  }
`;

export const GET_PRODUCT_BYID = gql`
  query GetProduct($id: ID!) {
    product(where: { id: $id }) {
      id
      title
      description
      productType {
        name
        requiresSizes
        image {
          publicUrl
          mimetype
          originalFilename
        }
      }
      selectedSize
      selectedMaterial
      materialPrices {
        materialName
        price
        isAvailable
        stockQuantity
        sizes {
          id
          label
          value
          gender
          productType
        }
        variantInventories {
          id
          stockQuantity
          isAvailable
          product {
            id
          }
          size {
            id
            label
            value
          }
        }
        materialIcon {
          icon {
            publicUrl
          mimetype
          originalFilename
          }
        }
      }
      sizes {
        value
      }
    }
  }
`;


export const GET_PRODUCTS_BY_TYPE = gql`
  query GetProductsByType($type: String!, $take: Int!, $skip: Int!) {
    products(
      where: {
        productType: {
          name: { equals: $type }
        }
      }
      take: $take
      skip: $skip
      orderBy: { title: asc }
    ) {
      id
      title
      selectedMaterial
    }
  }
`;

export const GET_PRODUCTS_BY_GENDER = gql`
  query GetProductsByGender($gender: String!, $take: Int!, $skip: Int!) {
    products(
      where: {
        gender: { equals: $gender }
      }
      take: $take
      skip: $skip
      orderBy: { title: asc }
    ) {
      id
      title
      selectedMaterial
    }
  }
`;

export const CURRENT = gql`
  query getCurrentUser {
    authenticatedItem {
      ... on User {
        id
        name
        email
        isAdmin
        marketingEmailsOptIn
        avatar {
          id
          publicUrl
          originalFilename
        }
      }
    }
  }
`;

export const GET_MARKETING_SUBSCRIBERS = gql`
  query GetMarketingSubscribers {
    users(where: { marketingEmailsOptIn: { equals: true } }, orderBy: { createdAt: desc }) {
      id
      name
      email
      marketingEmailsOptIn
    }
  }
`;

export const GET_USER_SHIPPING = gql`
  query GetUserShip {
    authenticatedItem {
      ... on User {
        shippingAddresses {
          id
          firstName
          lastName
          addressLine1
          addressLine2
          city
          postcode
          country
          province
          telephone
          phoneCode
          emoji
          useAddressForBilling
        }
      }
    }
  }
`;

export const ESTIMATE_ZIP_TAX = gql`
  query EstimateZipTax($input: ZipTaxAddressInput!, $subtotal: Float!) {
    estimateZipTax(input: $input, subtotal: $subtotal) {
      rate
      amount
      normalizedAddress
    }
  }
`;

export const VERIFY_SHIPPING_ADDRESS = gql`
  query VerifyShippingAddress($input: ShippingAddressVerificationInput!) {
    verifyShippingAddress(input: $input) {
      ok
      reason
      warning
    }
  }
`;

export const GET_LIKED_PRODUCT_BYID= gql`
  query GetLikedUserProducts($userId: ID!) {
    user(where: { id: $userId }) {
      products {
        id
        title
        selectedMaterial
      }
    }
  }
`

export const GET_CART_ITEMS_BY_USER= gql`
  query GetUserWithCartItems($userId: ID!) {
  user(where: { id: $userId }) {
    id
    name
    cartItems {
      id
      selectedSize
      selectedMaterial
      quantity
      product {
        id
        title
        productType {
          name
          requiresSizes
          image {
            publicUrl
          mimetype
          originalFilename
          }
        }
        materialPrices {
          materialName
          isAvailable
          stockQuantity
          sizes {
            id
            label
            value
          }
          variantInventories {
            id
            stockQuantity
            isAvailable
            product {
              id
            }
            size {
              id
              label
              value
            }
          }
          materialIcon {
            icon {
              publicUrl
          mimetype
          originalFilename
            }
          }
        }
        sizes {
          value
        }
      }
    }
  }
}
`

export const GET_COMMENTS_BY_PRODUCT = gql`
  query GetProductComments($productId: ID!) {
    product(where: { id: $productId }) {
      id
      title
      comments {
        id
        createdAt
        author {
          id
          name
        }
        commentItems {
          id
          content
          createdAt
          parent {
            id
          }
          images {
            id
            image {
              id
              publicUrl
              mimetype
              originalFilename
            }
          }
          replies {
            id
            content
            createdAt
            parent {
              id
            }
            author {
              id
              name
            }
            images {
              id
              image {
                id
                publicUrl
                mimetype
                originalFilename
              }
            }
          }
          author {
            id
            name
          }
        }
      }
    }
  }
`

export const CHECK_EXISTING_COMMENT = gql `
  query CheckExistingComment($productId: IDFilter!) {
    comments(where: { product: { id: $productId } }) {
      id
    }
  }
`

export const GET_IMG_BY_MATERIAL_FOR_PRODUCT = gql`
  query GetMaterialPriceAndImages($productId: ID!, $selectedMaterial: String!) {
  product(where: { id: $productId }) {
    materialPrices(where: { materialName: { equals: $selectedMaterial } }) {
      materialName
      price
      isAvailable
        stockQuantity
      sizes {
        id
        label
        value
      }
      variantInventories {
        id
        stockQuantity
        isAvailable
        product {
          id
        }
        size {
          id
          label
          value
        }
      }
      productImages{
        image {
          id
          publicUrl
          mimetype
          originalFilename
        }
      }
    }
  }
}
`

export const GET_MATERIAL_END_IMG_FOR_CART_ITEM = gql`
  query GetMaterialPriceAndImages($productId: ID!, $selectedMaterial: String!) {
  product(where: { id: $productId }) {
    materialPrices(where: { materialName: { equals: $selectedMaterial } }) {
      materialName
      price
      isAvailable
        stockQuantity
      sizes {
        id
        label
        value
      }
      variantInventories {
        id
        stockQuantity
        isAvailable
        product {
          id
        }
        size {
          id
          label
          value
        }
      }
      productImages(take: 1) {
        image {
          id
          publicUrl
          mimetype
          originalFilename
        }
      }
    }
  }
}
`
/* export const GET_MATERIAL_PRICE_AND_IMAGES_BY_PRODUCT = gql`
  query GetMaterialPriceAndImagesByProduct($productId: ID!, $materialName: String!) {
    product(where: { id: $productId }) {
      id
      materialPrices(where: { materialName: { equals: $materialName } }) {
        price
        productImages(take: 1) {
          image {
            publicUrl
          mimetype
          originalFilename
            id
          }
        }
      }
    }
  }
`; */

export const GET_IMAGES_BY_MATERIAL_FOR_HOME_PAGE = gql`
  query GetImagesByProductAndMaterial(
  $productId: ID!
  $materialName: String!
) {
  productImages(
    where: {
      AND: [
        { product: { id: { equals: $productId } } }
        { material: { materialName: { equals: $materialName } } }
      ]
    }
    take: 2
  ) {
    image {
      id
      publicUrl
          mimetype
          originalFilename
    }
  }
}
`;

export const GET_COUNTRIES = gql`
  query GetCountries {
    countries(where: { region: { equals: "Americas" } }, orderBy: { name: asc }) {
      id
      name
      phone_code
      emoji
    }
  }
`

export const GET_PROVINCES_BY_COUNTRY_NAME = gql`
  query States($where: StateWhereInput!) {
    states(where: $where, orderBy: { name: asc }) {
      id
      name
      country {
        id
        phone_code
        emoji
      }
    }
  }
`

export const GET_LIKED_PRODUCT_COUNT = gql`
  query GetLikedProductsCount($userId: ID!) {
    user(where: { id: $userId }) {
      products {
        id
      }
    }
  }
`

export const GET_CART_ITEMS_COUNT = gql`
  query GetCartItemsIdsAndCount($where: CartItemWhereInput!) {
    cartItems(where: $where) {
      id
    }
  }
`
export const GET_PRODUCT_DETAILS = gql`
  query GetProductWithDetails($id: ID!) {
    product(where: { id: $id }) {
      id
      productType {
        name
        requiresSizes
        image {
          publicUrl
          mimetype
          originalFilename
        }
      }
      details {
        style
        metal
        width
        length
        setting
        backing
      }
    }
  }
`;

export const GET_SEARCHED_PRODUCT = gql`
  query SearchProducts($search: String!) {
    products(
      where: {
        OR: [
          { title: { contains: $search, mode: insensitive } }
          { description: { contains: $search, mode: insensitive } }
        ]
      }
      orderBy: [{ createdAt: desc }]
    ) {
      id
      title
      gender
      price
      images(take: 1) {
        image {
          id
          publicUrl
          mimetype
          originalFilename
        }
      }
      productType {
        name
        requiresSizes
      }
      materialPrices {
        id
        materialName
        price
        isAvailable
        stockQuantity
        sizes {
          id
          label
          value
          gender
          productType
        }
        variantInventories {
          id
          stockQuantity
          isAvailable
          product {
            id
          }
          size {
            id
            label
            value
          }
        }
        productImages(take: 1) {
          image {
            id
            publicUrl
          mimetype
          originalFilename
          }
        }
      }
    }
  }
`;

export const GET_PAYD_ORDERS = gql`
  query GetPaydOrdersByUser($userId: ID!, $take: Int!, $skip: Int!) {
    paydOrdersCount(where: { user: { id: { equals: $userId } } })
    paydOrders(
      where: { user: { id: { equals: $userId } } }
      orderBy: [{ paymentDate: desc }]
      take: $take
      skip: $skip
    ) {
      id
      totalAmount
      status
      paymentMethod
      shippingAddress
      paymentDate
      items {
        id
        size
        quantity
        material
        product {
          id
          title
          
        }
      }
    }
  }
`;

export const GET_ADMIN_PAYD_ORDERS = gql`
  query GetAdminPaydOrders($take: Int!, $skip: Int!, $where: PaydOrderWhereInput! = {}) {
    paydOrdersCount(where: $where)
    paydOrders(orderBy: [{ paymentDate: desc }], take: $take, skip: $skip, where: $where) {
      id
      totalAmount
      status
      paymentMethod
      shippingAddress
      paymentDate
      user {
        id
        name
        email
        shippingAddresses(
          where: { useAddressForBilling: { equals: true } }
          orderBy: [{ createdAt: desc }]
          take: 1
        ) {
          id
          firstName
          lastName
          addressLine1
          addressLine2
          city
          postcode
          country
          province
          telephone
          phoneCode
        }
      }
      items {
        id
        size
        material
        quantity
        product {
          id
          title
          images(take: 1) {
            image {
              publicUrl
          mimetype
          originalFilename
            }
          }
        }
      }
    }
  }
`;

export const GET_PRICE_IMAGE_FOR_PAYD_ORDER = gql`
query GetPriceImage($productId: ID!, $material: String!) {
  materialPrices(
    where: {
      products: { some: { id: { equals: $productId } } }
      selectedMaterial: { equals: $material }
    }
  ) {
    price
    productImages(take: 1) {
      image {
        publicUrl
          mimetype
          originalFilename
      }
    }
  }
}
`;

export const GET_CART_ITEM_SELECTES_MAT_SIZE = gql`
    query GetCartItemsByIds($ids: [ID!]!) {
    cartItems(where: { id: { in: $ids } }) {
      id
      product {
        id
      }
      selectedSize
      selectedMaterial
    }
  }
`;
